module.exports = {
      id: "fb-usage",
      viewBox: "0 0 20 20",
      url: "/" + "sprite-326d1762f7ed1f924194ae9c5468ee69.svg#fb",
      toString: function () {
        return this.url;
      }
    }